import { Stack } from '@mui/material';

import { TetherInfoAlert } from '@/components/TetherInfoAlert';
import { SharedSpotterAlert } from '@/components/spotter/SharedSpotterIndicators';
import { DataTransmissionSection } from '@/components/spotter/configurationTab/DataTransmissionSection';
import { DeploymentConfigSection } from '@/components/spotter/configurationTab/DeploymentConfigSection';
import { DeviceDisplayNameSection } from '@/components/spotter/configurationTab/DeviceDisplayNameSection';
import { SensorConfigurationSection } from '@/components/spotter/configurationTab/SensorConfigurationSection';
import { ShareDataToggleSection } from '@/components/spotter/configurationTab/ShareDataToggleSection';
import { useIsSharedDevice } from '@/hooks/useIsSharedDevice';
import { useTetherDeviceIdentity } from '@/hooks/useTetherDeviceIdentity';

export const ConfigurationTabContainer = () => {
    const isSharedDevice = useIsSharedDevice();
    const { isScout, tetherDashboardUrl } = useTetherDeviceIdentity();

    return (
        <Stack gap={4}>
            {isSharedDevice && <SharedSpotterAlert unpermittedNoun="settings" />}
            {isScout && (
                <TetherInfoAlert
                    title="Configure Scout navigation on Tether"
                    href={tetherDashboardUrl}
                    actionButtonLabel="Configure on Tether"
                >
                    To change where and when your Scout moves, configure your mission plan, waypoints, and loiter on
                    Tether Dashboard.
                </TetherInfoAlert>
            )}
            <DeviceDisplayNameSection readOnly={isSharedDevice} />
            <ShareDataToggleSection readOnly={isSharedDevice} />
            <DeploymentConfigSection readOnly={isSharedDevice} />
            <DataTransmissionSection readOnly={isSharedDevice} />
            <SensorConfigurationSection />
        </Stack>
    );
};
